import { BrandedFooter } from '@components/branding';
import * as React from 'react';
import {
    ErrorPageContainer,
    ErrorContent
} from './styles';

const ErrorPage: React.FunctionComponent = () => {
    // NOTE: this needed to be hard coded, as if this would only show if the config or translations files failed,
    // and if this occurred, then there wouldn't be any translations available anyway...
    return (
        <ErrorPageContainer>
            <ErrorContent>
                Sorry, there was an error. Please try again later.
            </ErrorContent>
            <BrandedFooter />
        </ErrorPageContainer>
    );
};

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/screens/error-page/index.tsx